import {Component, OnInit} from "@angular/core";

@Component({
	selector: 'sign-up-header',
	templateUrl: './sign-up-header.component.html',
	styleUrls: ['./sign-up-header.component.less']
})
export class SignUpHeaderComponent implements OnInit {
	
	fullLandingUrl = window.fullLandingUrl

	headerButtonText = $localize`Go to Brixx.com`;

	isBusinessDoctors: boolean = false;

	constructor() {
		this.isBusinessDoctors = (String)(window['isBusinessDoctors']).toLowerCase() === 'true';
	}

	ngOnInit(): void {
	}
	
	goToLanding(): void {
		window.location.href = this.fullLandingUrl;
	}
	
}